import * as Yup from "yup";

export const activationSchema = (t) =>
  Yup.object().shape({
    email: Yup.string()
      .email(t("Register.EmailError"))
      .required(t("Register.EmailRequiredError")),
  });
